import { ChartBottomAxis } from 'components/atoms/chart/ChartBottomAxis/ChartBottomAxis'
import { UseChartContext } from 'components/atoms/chart/useChart'
import { FC } from 'react'
import styles from 'components/features/rewards/rewardPage/ChartAxisPreset/ChartAxisPreset.styl'


type ChartAxisPresetProps = {
  context: UseChartContext
  height: number
  width: number
}
export const ChartAxisPreset: FC<ChartAxisPresetProps> = (props) => {
  const { context, height, width } = props
  return (
    <>
      <ChartBottomAxis className={ styles.axisLine } context={ context } transform={ `translate(0, ${ height })` } />
      <ChartBottomAxis className={ styles.axisTicks } context={ context } transform={ `translate(${ width / 12 }, ${ height + 17 })` } />
    </>
  )
}
